import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const criteria = ['Your Frenchie has a sensitive tummy that never seems to settle', "You're tired of switching foods every few weeks", "You're not sure if you're feeding the right amount", 'You want a plan that actually sticks', "You'd rather follow a routine than chase trends."];
export function WhoSection() {
  return <section className="py-20 bg-[#F8FAFC]" data-id="element-248">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-249">
        <div className="max-w-3xl mx-auto" data-id="element-250">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center mb-12" data-id="element-251">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1E293B]" data-id="element-252">
              This Is Made For You If
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-xl border border-[#E2E8F0] p-8 md:p-10 shadow-sm mb-8" data-id="element-253">
            <ul className="space-y-4 mb-8" data-id="element-254">
              {criteria.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-255">
                  <CheckCircle2 className="w-6 h-6 text-[#0F766E] flex-shrink-0 mt-0.5" data-id="element-256" />
                  <span className="text-lg text-[#475569]" data-id="element-257">{item}</span>
                </motion.li>)}
            </ul>

            <div className="pt-6 border-t border-[#E2E8F0] space-y-2" data-id="element-258">
              <p className="text-[#475569]" data-id="element-259">
                Looking for a magic ingredient?{' '}
                <span className="font-semibold text-[#1E293B]" data-id="element-260">
                  That's not what this is.
                </span>
              </p>
              <p className="text-[#475569]" data-id="element-261">
                Looking for a feeding routine that actually works?{' '}
                <span className="font-semibold text-[#0F766E]" data-id="element-262">
                  You're in the right place.
                </span>
              </p>
            </div>
          </motion.div>

          {/* Imagine section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#F0FDFA] rounded-xl border-2 border-[#CCFBF1] p-8 md:p-10 text-center" data-id="element-263">
            <h3 className="text-2xl font-bold text-[#1E293B] mb-6" data-id="element-264">
              Picture This at Mealtime
            </h3>
            <div className="space-y-3 text-lg text-[#475569]" data-id="element-265">
              <p data-id="element-266">You know exactly what to put in the bowl.</p>
              <p data-id="element-267">You feel confident about portions.</p>
              <p data-id="element-268">You rotate proteins without second-guessing.</p>
              <p className="font-semibold text-[#1E293B] pt-4" data-id="element-269">
                No stress. No overthinking. No guilt.
              </p>
              <p className="text-[#0F766E] font-semibold" data-id="element-270">
                Just a calm, simple routine.
              </p>
              <p className="pt-4" data-id="element-271">
                And once it clicks, feeding your Frenchie feels easy again.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}